import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import LeaseDetails from './leaseDetails';
import Modal from 'react-bootstrap/Modal';
import TransectionDetails from './TransectionDetails';
import Deduction from './deduction';
import OtherDetails from './otherDetails';
import WindowedSelect from 'react-windowed-select';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseTermination = () => {
    const { currencyPrecision } = useCurrency();
    const apiService = new LeaseApiService();
    let navigate = useNavigate()
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false,]);
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);

    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const [proprtyList, setProperty] = useState([])
    const [loading, setloader] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)
    const [unitList, setUnitList] = useState([])
    const [leaseList, setLeaseList] = useState([])
    const [deductionList, setDeductionList] = useState([])
    const [receiptDetails, setReceiptDetails] = useState([])
    const [managerList, setManagerList] = useState([])
    const [remarksList, setRemarksList] = useState([])
    const [reasonList, setReasonList] = useState([])
    const [leaseDetails, setLeaseDetails] = useState()
    const [TransectionDetail, setTransectionDetails] = useState()

    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
        securityDeposit: 0,
    });

    const today = new Date();
    const totalDeductoin = deductionList?.filter(item => item.Exp3) // only include items where Exp3 is true/selected
        ?.reduce((sum, item) => sum + parseFloat(item.Exp2 || 0), 0)
        ?.toFixed(currencyPrecision?.decimalNumbers);
    // const totalDeductoin = deductionList?.reduce((sum, item) => sum + parseFloat(item.Exp2 || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const totalAmount = receiptDetails?.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData();
    }, [])
    const [transectionData, setTransectionData] = useState({
        transDate: formattedDate,
        NoticeDate: formattedDate,
        vacatingDate: formattedDate,
        vacationDate: formattedDate,
        returnDate: formattedDate,
        rentPerPeriod: '',
        securityDeposit: '',
        stayedPeriod: '',
        totalDeduction: '',
        totalAmountRec: '',
        sdRefund: '',
        rentAmtBalance: '',
        totalReceiveable: '',
        vacatingReason: '',
        remarks: '',
        glBalance: '',
        stayedRent: '',
        commReversal: '',
        calculatedDays: '',
        commReversal: '',
        manager: [],
        reasondrop: [],
        remarksDrop: [],
    });
    useEffect(() => {
        if (totalDeductoin) {
            const totalamount = deductionList?.filter(item => item.Exp3) // only include items where Exp3 is true/selected
                ?.reduce((sum, item) => sum + parseFloat(item.Exp2 || 0), 0)
                ?.toFixed(currencyPrecision?.decimalNumbers);
            setTransectionData((prev) => ({
                ...prev,
                totalDeduction: totalamount || 0,
            }));
            let TotalDedcution = totalamount
            let transecData = TransectionDetail
            let totalAmt = parseFloat(transectionData?.totalAmountRec)
            let RentBalance = transectionData?.stayedPeriod - totalAmt
            handleSDRefund(transectionData?.securityDeposit, TotalDedcution, RentBalance)
        }
    }, [deductionList])

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'TerminationCreatePropertyNames');
            const res = await apiService.getApiParamater('TERMINATION_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.PropertyNames)
            const leaparams = new URLSearchParams();
            leaparams.append('dropdownTypes', 'TerminationCreateLeaseNos');
            const leaRes = await apiService.getApiParamater('TERMINATION_MULTI', `?${leaparams.toString()}`);
            setLeaseList(leaRes?.data?.dropdowns?.LeaseNo)
            const LeaseParams = new URLSearchParams();
            LeaseParams.append('dropdownTypes', 'TerminationLeaseRemarks,TerminationPropetyManagerNames,TerminationReason');
            const leaseRes = await apiService.getApiParamater('TERMINATION_MULTI', `?${LeaseParams.toString()}`);
            setManagerList(leaseRes?.data?.dropdowns?.TerminationPropetyManagerNames)
            setRemarksList(leaseRes?.data?.dropdowns?.TerminationLeaseRemarks)
            setReasonList(leaseRes?.data?.dropdowns?.TerminationReason)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) =>
                    attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment
                ),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    const handleDelete = (id) => {
        const updatedList = attachmentList?.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    };
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        setTransectionData({
            transDate: formattedDate,
            NoticeDate: formattedDate,
            vacatingDate: formattedDate,
            vacationDate: formattedDate,
            returnDate: formattedDate,
            rentPerPeriod: '',
            securityDeposit: '',
            stayedPeriod: '',
            totalDeduction: '',
            totalAmountRec: '',
            sdRefund: '',
            rentAmtBalance: '',
            totalReceiveable: '',
            vacatingReason: '',
            remarks: '',
            glBalance: '',
            stayedRent: '',
            commReversal: '',
            calculatedDays: '',
            commReversal: '',
            manager: [],
            reasondrop: [],
            remarksDrop: [],
        })
        setTransectionDetails(null)
        setLeaseDetails([])
        setReceiptDetails([])
        setDeductionList([])
    }
    const handlePropertyChange = async (selectedOption) => {
        handleClearFilters()
        const params = new URLSearchParams();
        params.append('DropdownFor', 'TeminationCreateUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setFormData({ ...formData, Proprty: selectedOption });
    }
    const handleUitNo = async (selectedOption) => {
        handleClearFilters()
        let selectedLease = leaseList.find((comp) => comp.value === selectedOption?.value?.value)
        setFormData({
            ...formData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.value, value: selectedLease },
        });
    }
    const handleLeaseChange = (selectedOption) => {

        handleClearFilters()
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
        });
        setFormData({ ...formData, leaseNo: selectedOption });
    }
    const handleSearch = async () => {
        try {
            if (!formData?.leaseNo?.label) {
                toast.warning("Please Select Lease No First")
                return;
            } else {
                setSearchLoading(true);
                const duductoinParam = new URLSearchParams();
                duductoinParam.append('Action', 'GetLeaseDeductionMaster');
                const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
                const formattedData = (deductionRes?.data?.result?.data || []).map(item => ({
                    ...item,
                    Exp3: Number(item?.Exp3) || 0, // ensure 0 or 1
                }));

                setDeductionList(formattedData);

                // get by lease NO
                const leasedetailParam = new URLSearchParams();
                leasedetailParam.append('Action', 'GetLeaseDetailsByLeaseNo');
                leasedetailParam.append('LeaseNo', formData?.leaseNo?.label);
                const leasedetailRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${leasedetailParam.toString()}`);
                setLeaseDetails(leasedetailRes?.data?.result?.data)
                setTransectionDetails(leasedetailRes?.data?.result?.data)
                let transData = leasedetailRes?.data?.result?.data
                if (transData?.length !== 0) {
                    const SDparam = new URLSearchParams();
                    SDparam.append('Action', 'GetLeaseSecDepositByLeaseNo');
                    SDparam.append('LeaseNo', formData?.leaseNo?.label);
                    SDparam.append('TenantNo', transData?.Cust1_No);
                    const sdRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${SDparam.toString()}`);
                    // get by lease NO

                    let securityDep = sdRes?.data?.result?.data?.SecDeposit || transData?.SecurityDeposit || 0
                    const receiptParam = new URLSearchParams();
                    receiptParam.append('Action', 'GetReceiptDetailsByLeaseNo');
                    receiptParam.append('LeaseNo', formData?.leaseNo?.label);
                    const receiptRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${receiptParam.toString()}`);
                    let receptdata = receiptRes?.data?.result?.data?.Amount ? [receiptRes?.data?.result?.data] : receiptRes?.data?.result?.data
                    const amount = receptdata?.reduce((sum, item) => sum + parseFloat(item.Amount || 0), 0)?.toFixed(currencyPrecision?.decimalNumbers);
                    let selectedProperty = proprtyList?.find((comp) => comp.value === transData?.Property_Id)
                    const params = new URLSearchParams();
                    params.append('DropdownFor', 'TeminationCreateUnitNosByPropertyId');
                    params.append('CascadValue', selectedProperty?.value);
                    const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
                    setUnitList(res?.data?.items)
                    let selectedUnit = res?.data?.items?.find((comp) => comp.text === transData?.Unit_No)
                    setTransectionData((prev) => ({
                        ...prev,
                        totalAmountRec: amount,
                        rentPerPeriod: transData?.TotalPrice?.toFixed(currencyPrecision?.decimalNumbers),
                        securityDeposit: securityDep?.toFixed(currencyPrecision?.decimalNumbers) || "0.000",
                        totalDeduction: "0.000",
                        sdRefund: "0.000",
                        rentAmtBalance: (transData?.MonthlyRent - amount)?.toFixed(currencyPrecision?.decimalNumbers),
                        glBalance: 0,
                        monthRent: transData?.MonthlyRent,
                    }));
                    setFormData((prev) => ({
                        ...prev,
                        Proprty: { label: selectedProperty?.text, value: selectedProperty },
                        unitNo: { label: selectedUnit?.text, value: selectedUnit },
                        securityDeposit: securityDep?.toFixed(currencyPrecision?.decimalNumbers) || "0.000",
                    }));
                    let startDate = transData?.Lease_Date
                    const toDate = formatDate(formattedDate);
                    let monthRent = transData?.MonthlyRent
                    let refno = transData?.UnitRefNo || 0
                    await handleDayesStayed(startDate, formattedDate)
                    // revert back securityDep
                    await handleRentForStayedPeriod(startDate, toDate, monthRent, transData, amount, securityDep)
                    await handleagentData(toDate, refno, transData?.Cust1_No)
                    if (!receiptRes?.data?.result?.data?.Amount) {
                        setReceiptDetails(receiptRes?.data?.result?.data)
                    } else {
                        setReceiptDetails([receiptRes?.data?.result?.data])
                    }
                } else {
                    toast.error("No record in this lease No")
                }
            }
        } catch (error) {
            console.error('Error fetching  data:', error);
        } finally {
            setSearchLoading(false);
        }
    }
    const calculateDaysBetween = (startDate, vacatingDate) => {
        const diff = new Date(vacatingDate) - new Date(startDate);
        let leaseDate = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return leaseDate;
    }
    const handleDayesStayed = async (startDate, vacatingDate) => {
        const dayesstayed = calculateDaysBetween(startDate, vacatingDate);
        setTransectionData((prev) => ({
            ...prev,
            dayesStayed: dayesstayed,
        }));

    }
    const handleRentForStayedPeriod = async (startDate, toDate, monthRent, transData, amount, securityDep) => {
        const param = new URLSearchParams();
        if (transData?.Category_Mix === "US Navy") {
            param.append('Action', 'CalculateRentByMonthUSNAVY');
        } else {
            param.append('Action', 'CalculateRentByMonth');
        }
        param.append('PeriodFrom', startDate);
        param.append('PeriodTo', toDate);
        param.append('CommonDecimal', monthRent?.toFixed(currencyPrecision?.decimalNumbers));
        const res = await apiService.getApiParamater('TERMINATION_COMMON', `?${param.toString()}`);

        let stayedPeriod = res?.data?.result?.data?.[""]
        let totalAmountRec = transectionData?.totalAmountRec
        let RentBalance = stayedPeriod - (amount || totalAmountRec)
        let balanceRent = RentBalance?.toFixed(currencyPrecision?.decimalNumbers)
        let TotalDedcution = transectionData?.totalDeduction || 0
        let transecData = transData || TransectionDetail
        let security = securityDep || TransectionDetail?.SecurityDeposit || transectionData?.securityDeposit || 0
        
        setTransectionData((prev) => ({
            ...prev,
            stayedPeriod: stayedPeriod,
            actualStayedPeriod: stayedPeriod,
            securityDeposit: security || "0.000",
            rentAmtBalance: balanceRent
        }));
        // handleSDRefund(transectionData?.securityDeposit, TotalDedcution, balanceRent)

        handleSDRefund(security, TotalDedcution, balanceRent)
    }
    const handleagentData = async (toDate, refno, Cust1_No) => {
        const param = new URLSearchParams();
        param.append('Action', 'AgentRepayAmount');
        param.append('UnitRefNo', refno);
        param.append('PeriodTo', toDate);
        const res = await apiService.getApiParamater('TERMINATION_COMMON', `?${param.toString()}`);

        const Glparam = new URLSearchParams();
        Glparam.append('Action', 'GLBalanceCustomer');
        Glparam.append('TenantNo', Cust1_No);
        Glparam.append('PeriodTo', toDate);
        const GLRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${Glparam.toString()}`);
        let stayedPeriod = res?.data?.result?.data?.Amount
        let Balance = GLRes?.data?.result?.data?.Balance || 0
        setTransectionData((prev) => ({
            ...prev,
            agentAmount: stayedPeriod,
            glBalance: Balance
        }));

    }
    const handleSDRefund = async (Sd, TotalDedcution, RentBalance) => {
        let totalDeductions = parseFloat(TotalDedcution)
        let blnc = parseFloat(RentBalance || 0)
        let Sds = parseFloat(Sd || 0)
        let total = (-(blnc + totalDeductions - Sds))

        setTransectionData((prev) => ({
            ...prev,
            sdRefund: total?.toFixed(currencyPrecision?.decimalNumbers)
        }));
    }
    const handleSave = async () => {
        try {
            setloader(true);
            if (!formData?.Proprty?.label) {
                toast.warning("Please Select Property")
                setloader(false)
                return
            } else if (!formData?.leaseNo?.label) {
                toast.warning("Please Select Lease No")
                setloader(false)
                return
            }
            const currentDatetimeUTC = new Date().toISOString();
            const selecteddeduction = deductionList?.filter(
                item => item?.Exp3 === true || item?.Exp3 === 1
            );
            const deductionIndex = selecteddeduction?.map((item, index) => {
                return {
                    selected: true,
                    recordId: item?.RecordId || 0,
                    description: item?.Description || "0",
                    percentage: 0,
                    isFixedAmount: false,
                    fixedAmount: 0,
                    accountCode: item?.AccountCode || "0",
                    accountName: item?.AccountName || "0",
                    posting: item?.Posting,
                    taxCode: 0,
                    taxInclusive: false,
                    startOn: "1900-01-01T08:05:39.970Z",
                    taxPercent: 0,
                    xempted: false,
                    zero: false,
                    isVAT: false,
                    vatAcCode: "0",
                    vatAcName: "0",
                    quantity: parseFloat(item?.Category) || 0,
                    vatAmount: 0,
                    totalAmount: parseFloat(item?.Exp2) || 0,
                    remarks: item?.Remarks || "0",
                    fromRent: false,
                    amount: parseFloat(item?.Exp2) || 0
                };
            });
            let selectedProperty = proprtyList.find((comp) => comp.value === TransectionDetail?.Property_Id)
            let _LeaseTerminationDetails = {
                property_Id: TransectionDetail?.Property_Id,
                property_Name: selectedProperty?.text || "0",
                unit_No: TransectionDetail?.Unit_No,
                lease_No: TransectionDetail?.Lease_No,
                group_Id: TransectionDetail?.Group_Id,
                lease_Date: TransectionDetail?.Lease_Date,
                lease_Expiry: TransectionDetail?.Lease_Expiry,
                totalPrice: TransectionDetail?.TotalPrice.toString() || "0",
                cust1_No: TransectionDetail?.Cust1_No,
                cust1_Name: TransectionDetail?.Cust1_Name,
                contactNo: TransectionDetail?.MainContactNo,
                emailId: "0",
                passportId: "0",
                nationality: "0",
                vatRegNo: "0",
                leaseTerm: "0",
                noOfInstallment: "0",
                salesPerson: TransectionDetail?.SalesPerson,
                agent: TransectionDetail?.Agent,
                rentTotal: parseFloat(transectionData?.rentPerPeriod),
                totalInvoiced: 0,
                creditTotal: 0,
                receivedTotal: 0,
                transactionDate: moment(transectionData?.transDate).format(),
                noticeDate: moment(transectionData?.NoticeDate).format(),
                vacatingDate: moment(transectionData?.vacatingDate).format(),
                datePaidOnVacating: moment(transectionData?.vacationDate).format(),
                keyReturnDate: moment(transectionData?.returnDate).format(),
                actualLeaseAmount: parseFloat(transectionData?.rentPerPeriod),
                periodLeaseAmount: parseFloat(transectionData?.stayedPeriod),
                rentForStayedPeriod: parseFloat(transectionData?.rentPerPeriod),
                cancellationCharges: 0,
                balance: parseFloat(transectionData?.sdRefund),
                totalDeduction: parseFloat(transectionData?.totalDeduction),
                balanceLeaseAmount: parseFloat(transectionData?.rentAmtBalance),
                rentAmountBalance: 0,
                deposit: parseFloat(transectionData?.securityDeposit),
                totalDeductions: parseFloat(transectionData?.totalDeduction),
                miscCharges: 0,
                totalReceivable: 0,
                reason: transectionData?.vacatingReason,
                remarks_Comments: transectionData?.remarks,
                waterReading: 0,
                wReadingDate: "1900-01-01T08:05:39.970Z",
                elecReading: 0,
                eReadingDate: "1900-01-01T08:05:39.970Z",
                inspectionComments: "0",
                refundLetterSent: false,
                forwordingAddress: "0",
                otherRemarks_Comments: "0",
                adminFee: 0,
                otherFee: 0,
                finalBill: "0",
                originalDepositReceipt: (transectionData?.monthRent?.toFixed(currencyPrecision?.decimalNumbers)).toString(),
                empowerFB: "0",
                damageReport: "0",
                rentPaid: "0",
                leaseStatus: transectionData?.remarksDrop?.label || "0",
                otherDue: "0",
                isApproved: false,
                approvedBy: "0",
                approvedOn: "1900-01-01T08:05:39.970Z",
                isApproved1: false,
                approvedBy1: "0",
                approvedOn1: "1900-01-01T08:05:39.970Z",
                remarks: transectionData?.remarks || "0",
                remarks1: transectionData?.vacatingReason || "0",
                remarks2: "0",
                inspectionComment: "0",
                waterMeterReading: "0",
                wmrDate: "1900-01-01T08:05:39.970Z",
                electricalMeterReading: "0",
                emrDate: "1900-01-01T08:05:39.970Z",
                gasMeterReading: "0",
                gmrDate: "1900-01-01T08:05:39.970Z",
                forwardingAddress: "0",
                voucherNo: "0",
                postingId: "0",
                voucherSerialNo: 0,
                postingType: "0",
                financialYear: "0",
                exp1: transectionData?.totalAmountRec.toString() || "0.000",
                exp2: transectionData?.dayesStayed.toString() || "0",
                exp3: TransectionDetail?.LeaseTerm || "0",
                exp4: transectionData?.stayedPeriod.toString() || "0.000",
                exp5: "0",
                exp6: "0",
                exp7: "0",
                exp8: "0",
                exp9: transectionData?.manager?.label || "0",
                exp10: "0"
            }
            let _LeaseDetailsIndex = {
                recordId: 0,
                leaseNo: "string",
                groupId: 0,
                propertyNo: "string",
                propertyName: "string",
                unitNo: "string",
                rent: 0,
                tax: "string",
                vat: 0,
                total: 0,
                unitType: "string",
                unitCategory: "string"
            }
            const body = {
                leaseTerminationMain: {
                    _LeaseTerminationDetails: _LeaseTerminationDetails,
                    _LeaseDetailsIndex: _LeaseDetailsIndex,
                    deductionIndex: deductionIndex,
                    _AttachmentIndex: {
                        recordId: 0,
                        description: "string",
                        imgPath: "string"
                    },
                    _InvoiceIndex: {
                        recordId: 0,
                        groupId: 0,
                        leaseNo: "string",
                        category: "string",
                        description: "string",
                        dueDate: "2025-07-20T08:05:39.970Z",
                        invoiceNo: "string",
                        invoiceDate: "2025-07-20T08:05:39.970Z",
                        installmentAmount: 0,
                        tax: "string",
                        taxCode: 0,
                        taxInclusive: true,
                        vatPercent: 0,
                        vat: 0,
                        total: 0,
                        amountPaid: 0,
                        balance: 0,
                        refNo: "string",
                        narration: "string",
                        isSD: true,
                        isOther: true
                    },
                    _ReceiptIndex: {
                        recordId: 0,
                        leaseNo: "string",
                        groupId: 0,
                        psdId: 0,
                        description: "string",
                        receiptNo: "string",
                        receiptDate: "2025-07-20T08:05:39.970Z",
                        voucherNo: "string",
                        paymentMethod: "string",
                        chequeNo: "string",
                        chequeDate: "2025-07-20T08:05:39.970Z",
                        drawnOnBank: "string",
                        bankAccount: "string",
                        bankName: "string",
                        narration: "string",
                        isOther: true,
                        isSD: true,
                        isAdditionalAmount: true,
                        isOtherReceipt: true,
                        actualAmountPaid: 0,
                        installmentAmount: 0,
                        vat: 0,
                        total: 0
                    }
                }
            };

            const postRes = await apiService.post('POST_LEASE_TERMINATION', body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(postRes?.data?.message);

                handlePrint(postRes)
                setloader(false);
                navigate('/Lease/Management/Lease/Termination/Listing')
            } else {
                toast.warning(`${postRes?.data?.message}`);
                setloader(false);
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: TransectionDetail?.Lease_No },
                    { name: "reportName", value: 'LTER' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className="p-3">
            {/* Filters */}
            <div className='mb-3'><h6>Lease Termination Notice</h6></div>
            <div className='border-box2 p-2' style={{ borderRadius: "8px" }}>
                <div className='row'>
                    <div className='col-lg-8' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                        <div className='d-flex'>
                            <Select
                                className="w-100 p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Proprty}
                                onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                            />
                        </div>
                        <div className='d-flex'>
                            <Select
                                className="w-100 p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.unitNo}
                                onChange={(selectedOption) => handleUitNo(selectedOption)}
                                options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                            />
                        </div>
                        <div className='d-flex'>
                            <WindowedSelect
                                className="w-100  p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}

                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                menuShouldScrollIntoView={false}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                        color: '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',

                                            color: '#000',
                                        },
                                    }),
                                }}
                                options={
                                    leaseList
                                        ?.slice(0, 5000)
                                        .map(rec => ({ value: rec, label: rec?.value }))
                                }
                                value={formData.leaseNo}
                                onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                            />
                        </div>
                    </div>
                    <div className='col-4'>
                        <div className='d-flex gap-2'>
                            {searchLoading === true ?
                                <div className='mainbtnGry flex-end gap-2 w-50'>
                                    <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                </div>
                                :
                                <div className='mainbtnGry flex-end gap-2 w-50' onClick={handleSearch}>
                                    <IoSearch color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                            }
                            {loading === true ?
                                <div className='mainbtn flex-end gap-2 w-50'>
                                    <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                </div>
                                :
                                <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                                    <FaSave color='#fff' className='center mt-2 mx-2' />
                                    <div className='center'>Save</div>
                                </div>
                            }
                        </div>
                        <div className='d-flex mt-1 gap-2'>
                            <div className='mainbtnSecondary flex-end gap-2 w-50' onClick={handleBackClick}>
                                <FaChevronLeft color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Back</div>
                            </div>
                            <div className='mainbtnRed flex-end gap-2 w-50' onClick={handleClearFilters}>
                                <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                <div className='center'>Reset</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className='nav nav-pills overslid d-flex gap-4'>
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(0)}>Lease Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(1)}>Transaction Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(2)} >Deductions
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(3)} >Other Details
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`}
                        onClick={() => handleTabClick(4)} >Attachments
                    </div>
                </div>
            </div>
            {/* Lease Details */}
            {gridVisibility[0] && (<LeaseDetails leaseDetails={leaseDetails} formData={formData} handleSDRefund={handleSDRefund} />)}
            {gridVisibility[1] && (<TransectionDetails managerList={managerList} remarksList={remarksList} reasonList={reasonList} TransectionDetail={TransectionDetail} setTransectionData={setTransectionData} transectionData={transectionData}
                leaseDetails={leaseDetails}
                handleagentData={handleagentData} handleSDRefund={handleSDRefund}
                calculateDaysBetween={calculateDaysBetween} handleRentForStayedPeriod={handleRentForStayedPeriod} />)}
            {gridVisibility[2] && (<Deduction deductionList={deductionList} setDeductionList={setDeductionList} setTransectionData={setTransectionData} handleSDRefund={handleSDRefund} />)}
            {gridVisibility[3] && (<OtherDetails />)}
            {gridVisibility[4] && (
                <div className='border-box2 p-4' style={{ borderRadius: "8px" }}>
                    <div className="col d-flex justify-content-between">
                        <input className="form-Input w-100" placeholder='Enter Description' />
                    </div>
                    <div className="pt-2">
                        <table>
                            <thead className="dynoTable">
                                <tr>
                                    <th>File Name</th>
                                    <th>Remarks</th>
                                    <th>Upload</th>
                                    <th>View</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attachmentList?.map((attachment, index) => (
                                    <tr key={attachment.id}>
                                        <td className='m-0 p-0 col-6'><input className='p-0' type='text' disabled value={attachment.fileName} style={{ width: "100%" }} /></td>
                                        <td className=' col-6'>
                                            <input type="text" value={attachment.remarks}
                                                onChange={(e) => {
                                                    const updatedList = attachmentList?.map((item) =>
                                                        item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                    );
                                                    setAttachmentList(updatedList);
                                                }}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td>
                                            <button className='mainbtn ' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                            <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleFileSelect(e, attachment.id)}
                                                id={`fileInput-${attachment.id}`}
                                                accept=".png,.jpg,.jpeg,.gif,.bmp,.pdf,.doc,.docx"
                                            />
                                        </td>
                                        <td><button className='mainbtnRed ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                            <div>View</div></button></td>
                                        <td>
                                            <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary'>
                                                <div>Delete</div></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div>
                <div>
                    <h6>Receipt Detail</h6>
                </div>
                <div className='gridshad mt-1'>
                    <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                        <table>
                            <thead className='dynoTable'>
                                <tr>
                                    <th>Receipt No</th>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th>Amount</th>
                                    <th>Payment Method</th>
                                    <th>Cheque No</th>
                                    <th>Cheque Date</th>
                                    <th>Chq Status</th>
                                    <th>Credit Account</th>
                                    <th>Debit Account</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(receiptDetails) && receiptDetails?.map((data, index) => (
                                    <tr>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.ReceiptNo} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.PaymentDate} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.Description} disabled style={{ width: "200px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={Number(data?.Amount)?.toFixed(currencyPrecision?.decimalNumbers)} disabled style={{ width: "100px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.PaymentMethod} disabled style={{ width: "170px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.ChequeNo} disabled style={{ width: "110px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.ChequeDate} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.ChequeStatus} disabled style={{ width: "130px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.CreditAccount} disabled style={{ width: "350px" }} /></td>
                                        <td className='m-0 p-0'><input className='p-1' value={data?.DebitAccount} disabled style={{ width: "250px" }} /></td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan="3" className='m-0 p-0'><input className='p-1 w-100' disabled value={"Total"} /></td>
                                    <td><input style={{ width: "100px" }} className='p-1' type="text" disabled value={totalAmount || "0.000"} /></td>
                                    <td colSpan="6" ><input className='p-1 w-100' type="text" disabled value={""} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Image Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                </Modal.Body>
            </Modal>
        </div>

    );
};
export default LeaseTermination;
